<template>
  <div class="dropdown-button">
    <button :class="buttonCss" :disabled="disabled">
      <slot name="button">
        {{text}}
        <icon name="triangle-down" />
      </slot>
    </button>
    <div ref="dropdown" :class="dropdownCss">
      <slot />
    </div>
  </div>
</template>

<script>
import Button from '@/mixins/Button';
import UIkitComponentWrapper from '@/mixins/UIkitComponentWrapper';

export default {
  name: 'dropdown-button',
  mixins: [
    Button,
    UIkitComponentWrapper({
      name: 'dropdown',
      ref: 'dropdown',
      props: [
        'mode', 'pos', 'flip', 'offset', 'delayShow',
        'delayHide', 'boundary', 'boundaryAlign',
      ],
      events: [
        'toggle', 'beforeshow', 'show', 'shown',
        'beforehide', 'hide', 'hidden',
      ],
      delegate: ['show', 'hide'],
    }),
  ],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'click',
    },
    pos: {
      type: String,
      default: 'bottom-left',
    },
    flip: {
      type: Boolean,
      default: true,
    },
    offset: {
      type: Number,
      default: 0,
    },
    delayShow: {
      type: Number,
      default: 0,
    },
    delayHide: {
      type: Number,
      default: 0,
    },
    contentSize: String,
    boundary: String,
    boundaryAlign: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dropdownCss() {
      return {
        [`uk-width-${this.contentSize}`]: !!this.contentSize,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// DropdownButton.vue?24b8beff